<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="clear"></div>

<div class="container-preview">
  <div class="chart-preview-section" *ngIf="!chartContent?.showStaticChart">
    <div class="chart-preview-section__body">
      <ng-container *ngIf="chartContent?.chartType === 'RADAR'">
        <ptl-radar-chart-preview
          #chartComponent
          [selectedUserScoreVersion]="chartVersionEnd"
          [chartContent]="chartContent"
          [includeSelfFeedback]="includeSelfFeedback"
        >
        </ptl-radar-chart-preview>
      </ng-container>

      <ng-container *ngIf="chartContent?.chartType === 'RADIAL'">
        <ptl-polar-chart-preview
          #chartComponent
          [chartVersionStart]="chartVersionStart"
          [chartVersionEnd]="chartVersionEnd"
          [chartContent]="chartContent"
        >
        </ptl-polar-chart-preview>
      </ng-container>

      <ng-container *ngIf="chartContent?.chartType === 'BAR'">
        <ptl-bar-chart-preview
          #chartComponent
          [chartVersionStart]="chartVersionStart"
          [chartVersionEnd]="chartVersionEnd"
          [chartContent]="chartContent"
        ></ptl-bar-chart-preview>
      </ng-container>
    </div>
    <div class="chart-preview-version-select" *ngIf="chartContent?.versionedScores?.length >= 2">
      @if (chartContent?.chartType === 'RADAR' && includeSelfFeedback) {
        <div class="chart-preview-version-select-title" tabindex="0">Show user results from:</div>
      } @else {
        <div class="chart-preview-version-select-title small" tabindex="0">
          {{ 'translations.report.title.compareCompletionDates' | transloco }}
        </div>
      }
      <div class="chart-preview-version-select-box">
        <mat-form-field class="date-field" appearance="outline" *ngIf="chartContent?.chartType !== 'RADAR'">
          <div class="chart-preview-background-color-striped" *ngIf="chartContent?.chartType === 'BAR'"></div>
          <mat-select
            [attr.aria-label]="'translations.global.ariaLabels.chooseFirstCompletionDate' | transloco"
            [(ngModel)]="chartVersionStart"
          >
            <mat-option
              *ngFor="let completion of chartContent?.versionedScores"
              [value]="completion.version"
              [disabled]="completion.version === chartVersionEnd"
            >
              {{ completion.completedOn | dateFormat: 'D MMMM y, HH:mm' }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="date-field" appearance="outline">
          <div class="chart-preview-background-color" *ngIf="chartContent?.chartType === 'BAR'"></div>
          <mat-select
            [attr.aria-label]="'translations.global.ariaLabels.chooseSecondCompletionDate' | transloco"
            [(ngModel)]="chartVersionEnd"
          >
            <mat-option
              *ngFor="let completion of chartContent?.versionedScores"
              [value]="completion.version"
              [disabled]="completion.version === chartVersionStart && chartContent?.chartType !== 'RADAR'"
            >
              {{ completion.completedOn | dateFormat: 'D MMMM y, HH:mm' }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button
          mat-flat-button
          class="apply-button"
          color="primary"
          [attr.aria-label]="'translations.global.ariaLabels.pressEnterToApplyChanges' | transloco"
          (click)="applyDateFilter()"
        >
          {{ 'translations.global.button.apply' | transloco }}
        </button>
      </div>
    </div>
  </div>

  <div class="chart-preview-section" *ngIf="chartContent?.showStaticChart">
    <div class="chart-preview-section__static">
      <img *ngIf="chartContent?.chartType === 'RADAR'" src="../assets/chart-radar.jpg" width="516" height="475" alt="chart" />
      <img *ngIf="chartContent?.chartType === 'RADIAL'" src="../assets/chart-radial.jpg" width="302" height="302" alt="chart" />
      <img *ngIf="chartContent?.chartType === 'BAR'" src="../assets/chart-bar.jpg" width="813" height="365" alt="chart" />
    </div>
  </div>
</div>
